import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emailSettingAccountNotSynced" }
const _hoisted_2 = { class: "emailSettingAccountNotSynced__content-wrapper" }
const _hoisted_3 = { class: "emailSettingAccountNotSynced__content" }
const _hoisted_4 = { class: "emailSettingAccountNotSynced__title" }
const _hoisted_5 = { class: "emailSettingAccountNotSynced__subtitle" }

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailSettingAccountNotSynced',
  props: {
    isEmailsSentFromCorp: { type: Boolean }
  },
  setup(__props: any) {



const store = useStore();
const isAdmin = computed(() => store.state.user.isAdmin);

return (_ctx: any,_cache: any) => {
  const _component_CompassButton = _resolveComponent("CompassButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("img", { src: "/ressources/logged/img/illustrations/no-email-connected.svg" })
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t.__('email.EmailSettingAccountNotSynced.title')), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t.__('email.EmailSettingAccountNotSynced.subtitle')), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", null, [
      (isAdmin.value || !__props.isEmailsSentFromCorp)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'onboarding.email' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CompassButton, {
                label: _ctx.$t.__('email.configure_email_service')
              }, null, 8 /* PROPS */, ["label"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})